<gbc-modal [title]="data.title">
  <gbc-modal-content>
    @if (data.iconUrl) {
      <img class="icon" [src]="data.iconUrl">
    }
    @if (data.headline) {
      <h4 class="headline">{{data.headline}}</h4>
    }
    {{data.content}}
  </gbc-modal-content>
  <gbc-modal-buttons>
    @for (action of data.actions; track action) {
      <button gbc-modal-button
        (click)="selectAction(action)"
        [ngClass]="{danger: action.type === 'danger', primary: action.type === 'primary'}"
        >
        {{action.text}}
      </button>
    }
  </gbc-modal-buttons>
</gbc-modal>
